import { compressImage } from './utils/imageCompressor';

const API = window.__BASE_PATH__ !== undefined 
  ? `${window.__BASE_PATH__}/api` 
  : (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
      ? '/369films/api' 
      : 'https://369films.com.ar/api');

const authHeaders = () => {
  const token = localStorage.getItem('admin_token');
  return { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) };
};

const authHeadersGet = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const getUrl = (path) => {
  const token = localStorage.getItem('admin_token');
  return token ? `${API}${path}?token=${encodeURIComponent(token)}` : `${API}${path}`;
};

const handleResponse = (res) => {
  if (res.status === 401) {
    localStorage.removeItem('admin_token');
    window.location.reload();
  }
  return res.json();
};

export const login  = (user, pass) => fetch(`${API}/login`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ username: user, password: pass }) }).then(r => r.json());
export const logout = () => localStorage.removeItem('admin_token');
export const isLogged = () => !!localStorage.getItem('admin_token');

export const getSettings  = () => fetch(getUrl('/settings')).then(handleResponse);
export const saveSettings = (data) => fetch(getUrl('/settings'), { method:'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(handleResponse);

export const uploadLogo = async (file) => {
  const compressed = await compressImage(file);
  const fd = new FormData(); fd.append('logo', compressed);
  const token = localStorage.getItem('admin_token');
  if (token) fd.append('__token', token);
  return fetch(getUrl('/upload-logo'), { method:'POST', headers: token ? { 'Authorization': `Bearer ${token}` } : {}, body: fd }).then(handleResponse);
};

export const uploadLogoCircular = async (file) => {
  const compressed = await compressImage(file);
  const fd = new FormData(); fd.append('logo', compressed);
  const token = localStorage.getItem('admin_token');
  if (token) fd.append('__token', token);
  return fetch(getUrl('/upload-logo-circular'), { method:'POST', headers: token ? { 'Authorization': `Bearer ${token}` } : {}, body: fd }).then(handleResponse);
};

export const uploadImage = async (file) => {
  const compressed = await compressImage(file);
  const fd = new FormData(); fd.append('image', compressed);
  const token = localStorage.getItem('admin_token');
  if (token) fd.append('__token', token);
  return fetch(getUrl('/upload-image'), { method:'POST', body: fd }).then(handleResponse);
};

export const getPosts   = () => fetch(getUrl('/posts')).then(handleResponse);
export const createPost = (data) => fetch(getUrl('/posts'), { method:'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(handleResponse);
export const updatePost = (id, data) => fetch(getUrl(`/posts/${id}`), { method:'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(handleResponse);
export const deletePost = (id) => fetch(getUrl(`/posts/${id}`), { method:'DELETE', headers: authHeaders() }).then(handleResponse);

export const getCategories   = () => fetch(getUrl('/categories')).then(handleResponse);
export const createCategory = (data) => fetch(getUrl('/categories'), { method:'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(handleResponse);
export const deleteCategory = (id) => fetch(getUrl(`/categories/${id}`), { method:'DELETE', headers: authHeaders() }).then(handleResponse);

export const getUsers   = () => fetch(getUrl('/users'), { headers: authHeadersGet() }).then(handleResponse);
export const createUser = (data) => fetch(getUrl('/users'), { method:'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(handleResponse);
export const updateUser = (id, data) => fetch(getUrl(`/users/${id}`), { method:'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(handleResponse);
export const deleteUser = (id) => fetch(getUrl(`/users/${id}`), { method:'DELETE', headers: authHeaders() }).then(handleResponse);

export const getRedes   = () => fetch(getUrl('/redes')).then(handleResponse);
export const createRed  = (data) => fetch(getUrl('/redes'), { method:'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(handleResponse);
export const deleteRed  = (id) => fetch(getUrl(`/redes/${id}`), { method:'DELETE', headers: authHeaders() }).then(handleResponse);